export const RECORD_TYPES = {
  SalesOrder: "SO",
  RepairOrder: "RO",
  InventoryTransferOrder: "TR",
  ManagedRepairOrder: "MR",
  PurchaseOrder: "CR",
  ReturnedCore: "CR",
  Rma: "RMA",
  ReturnToCustomerRecord: "RMA",
  ReturnedConsignment: "RC"
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/constants.js